export default __webpack_public_path__ + "static/media/mobile-hori.ced913e8.png";